import "./Home.css";

import logo1 from "../Assets/Icons/Logo/4.png";
import logo2 from "../Assets/Icons/Logo/5.png";
import logo3 from "../Assets/Icons/Logo/6.png";
import logo4 from "../Assets/Icons/Logo/7.png";
import logo6 from "../Assets/Icons/Logo/9.png";
import logo7 from "../Assets/Icons/Logo/10.png";
import logo8 from "../Assets/Icons/Logo/11.png";
import logo9 from "../Assets/Icons/Logo/12.png";
import logo10 from "../Assets/Icons/Logo/13.png";
import logo11 from "../Assets/Icons/Logo/14.png";
import logo12 from "../Assets/Icons/Logo/15.png";
import logo13 from "../Assets/Icons/Logo/16.png";

const LogoSection = () => {
  const logos = [
    { src: logo1, alt: "Amazon" },
    { src: logo2, alt: "Bill" },
    { src: logo3, alt: "Drake" },
    { src: logo4, alt: "Ebay" },
    { src: logo6, alt: "Payoneer" },
    { src: logo7, alt: "Paypal" },
    { src: logo8, alt: "QuickBooks" },
    { src: logo9, alt: "Shopify" },
    { src: logo10, alt: "Stripe" },
    { src: logo11, alt: "Xero" },
    { src: logo12, alt: "ZohoBooks" },
    { src: logo13, alt: "ZohoPayroll" },
  ];

  return (
    <div className="logo-section py-5">
      <div className="container text-center">
      <h1 className="fw-bold">
      We work with lots of apps….Check out some of them!
            </h1>
        <div className="row">
          {logos.map((logo, index) => (
            <div
              className="col-lg-1-5 col-md-4 col-sm-4 col-4 mb-4 text-center"
              key={index}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="img-fluid logo-img"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoSection;